import { useEffect, useState } from 'react';
import { disparoEmAndamento } from '@/lib/estadoDeSessao';
import { recarregarPagina, vigiarVersao } from '@/lib/versao';

/**
 * ★★★ WU/U2 — A FAIXA "nova versão disponível". **Avisa; não recarrega.**
 *
 * ⚠⚠ Por que não recarregar sozinho: a medição da WU listou o que se perde num reload — ★★★ o
 * **lote inteiro da Confirmação de Agenda, com o disparo em andamento**, a mensagem sendo
 * digitada, o **áudio gravado e não enviado**, o anexo escolhido, e o conteúdo das 9 seções de
 * Configurações. ★ Tudo isso vive em memória (`estadoDeSessao` é um `Map`) ou em `useState`.
 *
 * ★★ `recarregarSozinho` existe para UM caso: a tela de **login**, onde não há trabalho a
 * perder. ⚠ Quem decide é o `AppShell` (ele sabe se há sessão), não este componente.
 */
export default function FaixaNovaVersao({ recarregarSozinho = false, recarregar, opcoes }) {
  const [nova, setNova] = useState(false);
  /**
   * ★★ O disparo é lido a cada 2 s ENQUANTO a faixa está visível.
   *
   * ⚠ `estadoDeSessao` é um `Map` em memória, sem assinatura — não há como ele avisar que o
   * lote terminou. ★ Reler é de graça (leitura de `Map`), e é o que **destrava o botão sozinho**
   * quando o disparo acaba, sem a pessoa precisar adivinhar.
   */
  const [travado, setTravado] = useState(false);

  useEffect(() => vigiarVersao(() => setNova(true), opcoes ?? {}), [opcoes]);

  useEffect(() => {
    if (!nova) return undefined;
    const ler = () => setTravado(disparoEmAndamento());
    ler();
    const t = setInterval(ler, 2000);
    return () => clearInterval(t);
  }, [nova]);

  useEffect(() => {
    // ★ Login: sem trabalho a perder, atualiza na hora. ⚠ Só aqui.
    if (nova && recarregarSozinho) (recarregar ?? recarregarPagina)();
  }, [nova, recarregarSozinho, recarregar]);

  if (!nova || recarregarSozinho) return null;

  return (
    <div className="faixa-nova-versao" role="status">
      <span>Nova versão disponível.</span>
      <button
        type="button"
        /**
         * ⚠⚠ A guarda do clique é DUPLA: o `disabled` reflete a última leitura, ★★★ e o
         * `onClick` relê antes de recarregar. Dois segundos de defasagem são suficientes para
         * um clique chegar no instante em que o disparo começa.
         */
        disabled={travado}
        title={travado ? 'Atualize depois do disparo' : 'Recarrega a página com a versão nova'}
        onClick={() => {
          if (disparoEmAndamento()) {
            setTravado(true);
            return;
          }
          (recarregar ?? recarregarPagina)();
        }}
      >
        {travado ? 'Atualize depois do disparo' : 'Atualizar'}
      </button>
    </div>
  );
}
